const revokeWorkspace = {
    bindings: {
      workspace: '<',
      mode: '<',
      onSubmit: '&',
      onCancel: '&'
    },
    templateUrl:
      '/modules/pis-tool/workspaces/workspace-modal/revoke-workspace/revoke-workspace.html',
  };
  
  angular
    .module('pis-tool.module')
    .component('revokeWorkspace', revokeWorkspace);
  